import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ToolbarItems from './ToolbarItems/ToolbarItems';
import BackButton from './BackButton/BackButton';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    closeNavigation,
    openNavigation
} from '../../Navigation/actions';
import { getIsNavigationOpen } from '../../Navigation/viewState';
import classNames from 'classnames';
import { goBack } from '../../Routes/routesActions';
import {
    getGoBackTarget,
    getCurrentLocationTitle,
    getIsCurrentRouteNavLinkRoute
} from '../../Routes/routesEntity';
import {
    goBackTargetShape,
    historyShape
} from '../../../utils/propTypes';
import './Header.scss';
import { getAccountName } from '../../UserData/userDataEntity';
import { getIsLoggedInAs, getAccountType } from '../../Self/selfEntity';
import _ from 'lodash';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

export class Header extends Component {
    static propTypes = {
        currentLocationTitle: PropTypes.string,
        goBackTarget: goBackTargetShape,
        history: historyShape,
        isErrorPage: PropTypes.bool,
        isNavigationOpen: PropTypes.bool,
        isNavLinkRoute: PropTypes.bool,
        isSearchOpen: PropTypes.bool,
        onCloseNavigation: PropTypes.func.isRequired,
        onGoBack: PropTypes.func.isRequired,
        onOpenNavigation: PropTypes.func.isRequired,
        accountName: PropTypes.string,
        isLoggedInAs: PropTypes.bool,
        accountType: PropTypes.string
    };

    render() {
        const containerClassName = classNames('header-container',
            {
                'search-open': this.props.isSearchOpen,
                'show-back': !this.props.isNavLinkRoute && this.props.goBackTarget
            }
        );

        return (
            <header className="emvio-header" >
                {
                    this.props.isLoggedInAs ?
                        <div className="warning-banner">
                            You are currently logged in as {this.props.accountName}
                        </div> :
                        ''
                }
                <div className={containerClassName}>
                    {this.props.isNavLinkRoute ? <div className="drawer-button-area"
                        onClick={this.props.isNavigationOpen ? this.props.onCloseNavigation : this.props.onOpenNavigation}>
                        <div className="drawer-button">
                            <span className="icon-menu" />
                        </div>
                    </div> : null}
                    {!this.props.isNavLinkRoute && !_.get(this.props.goBackTarget, 'noMatch') && _.get(this.props.goBackTarget, 'title') ? <BackButton
                        buttonAction={this.props.onGoBack(this.props.history, this.props.goBackTarget)}
                        buttonText={this.props.goBackTarget.title}
                    /> : null}
                    <div className="header-title">
                        {this.props.flags?.resellerPhase1 && this.props.currentLocationTitle === 'OVERVIEW' ? 'PORTFOLIO' : ''} {this.props.isErrorPage ? 'ERROR' : this.props.currentLocationTitle}
                    </div>
                    <div className="header-menu">
                        <ToolbarItems
                            isSearchOpen={this.props.isSearchOpen}
                            accountType={this.props.accountType}
                            currentPath={this.props.history.location.pathname}
                        />
                    </div>
                </div>
            </header>
        );
    }
}

function mapStateToProps(state) {
    return {
        currentLocationTitle: getCurrentLocationTitle(state),
        goBackTarget: getGoBackTarget(state),
        isNavigationOpen: getIsNavigationOpen(state),
        isNavLinkRoute: getIsCurrentRouteNavLinkRoute(state),
        accountName: getAccountName(state),
        isLoggedInAs: getIsLoggedInAs(state),
        accountType: getAccountType(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCloseNavigation: () => dispatch(closeNavigation()),
        onGoBack: (history, goBackTarget) => () => goBack(history, goBackTarget),
        onOpenNavigation: () => dispatch(openNavigation())
    };
}

export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)));
